var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestMobileRepin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 9,
  viewBox: "0 0 8 9",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M3.291 1.5v.4s-.5.322-.515.516c.003.198.013 1.91.015 2.268v.066s.654.41.696.489c.208.303.054.561.054.561l-1.25-.05-.5 3.15-.515-3.15L.04 5.8s-.125-.274.062-.56c.063-.097.688-.49.688-.49v-.065L.807 2.43C.807 2.257.29 1.9.29 1.9v-.4zM5.805 0l.515 3.15 1.235-.05s.126.274-.061.56c-.063.097-.69.49-.69.49v.065c-.002.357-.011 2.063-.014 2.254-.001.174.515.531.515.531v.4h-3V7s.5-.322.515-.516l-.015-2.268V4.15s-.654-.41-.695-.489c-.21-.303-.055-.561-.055-.561l1.25.05z"
})));
export default SvgPinterestMobileRepin;